/* eslint-disable */
import React from 'react';
import Navbar        from '../components/landing-page/Navbar';
import Hero          from '../components/landing-page/Hero';
import About         from '../components/landing-page/About';
import Services      from '../components/landing-page/Services';
import WhyUs         from '../components/landing-page/WhyUs';
import Testimonials  from '../components/landing-page/Testimonials';
import FAQ           from '../components/landing-page/FAQ';
import CTA           from '../components/landing-page/CTA';
import Contact       from '../components/landing-page/Contact';
import Footer        from '../components/landing-page/Footer';
import WhatsAppButton from '../components/landing-page/WhatsAppButton';

function LandingPage() {
  return (
    <div className="min-h-screen bg-navy-950">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyUs />
        <Testimonials />
        <FAQ />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default LandingPage;
